import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { api } from '@/lib/axios';
import { API_ROUTES } from '@/constants/routes';
import type { Lead } from '@/types/leads';

export interface UpdatePlacePayload {
  displayName?: string;
  formattedAddress?: string;
  internationalPhoneNumber?: string;
  websiteUri?: string;
}

interface ApiErrorResponse {
  detail?: string;
  displayName?: string[];
  formattedAddress?: string[];
  internationalPhoneNumber?: string[];
  websiteUri?: string[];
  [key: string]: string[] | string | undefined;
}

export const useUpdatePlace = () => {
  const queryClient = useQueryClient();
  return useMutation<
    Lead,
    AxiosError<ApiErrorResponse>,
    { id: string; payload: UpdatePlacePayload }
  >({
    mutationFn: async ({ id, payload }) => {
      const { data } = await api.patch<Lead>(`${API_ROUTES.places}${id}/`, payload);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['places'] });
      queryClient.invalidateQueries({ queryKey: ['recipients'] });
    },
  });
};
